import React, {Component, Fragment} from "react";
import {Button, Header} from "semantic-ui-react";
import store from "../../store";
import * as channelActions from "../../actions/channelActions"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DataTable from "../shared/DataTable";
import LoadingSpinner from "../shared/spinner/LoadingSpinner";
import InfoWrapper from "../shared/error/InfoWrapper";
import {InfoWrapperTypes} from "../../global/InfoWrapperTypes";
import {isEmpty} from "../../helpers/ObjectHelper";
import FormMessageContainer from "../../containers/FormMessageContainer";
import EditChannel from "./EditChannel";
import DeleteChannel from "./DeleteChannel";
import AddChannel from "./AddChannel";

class Channels extends Component<any, any> {
    constructor(props : any){
        super(props);
        this.update = this.update.bind(this);
    }
    componentDidMount(): void {
        this.update();
    }

    update(): void {
        store.dispatch(channelActions.getChannels());
    }

    addChannel(): void {
        store.dispatch(channelActions.addChannelForm());
    }

    deleteChannel(id : string) : void {
        store.dispatch(channelActions.getChannelAndCallAction(id, "delete"));
    }

    editChannel(id : string) : void {
        store.dispatch(channelActions.getChannelAndCallAction(id, "edit"));
    }

    renderActions(element : any) {
        return (
            <Fragment>
                <a href="#" onClick={() => this.deleteChannel(element.idChannel)}><FontAwesomeIcon icon={['fas', 'trash']} /> Löschen</a>
                <a href="#" onClick={() => this.editChannel(element.idChannel)}><FontAwesomeIcon icon={['fas', 'edit']} /> Bearbeiten</a>
            </Fragment>
        )
    }

    addActions(items : any) : void {
        items.map((element : any) => {
            element.action = this.renderActions(element);
        });
    }

    render() {
        const {store, channels} = this.props;
        this.addActions(channels);
        let headings = [
            {"name" : "ID", "sortkey" : "idChannel"},
            {"name" : "Channelname", "sortkey" : "name"},
            {"name" : "Aktionen", "sortkey" : "action"}
        ];
        return(
            <>
                <Header as="h1" className="mainHeader">Stream Channels</Header>
                {isEmpty(store.selectedObject) && store.state !== "add" &&
                    <div className="button-group">
                        <Button onClick={this.addChannel} type="button" ><FontAwesomeIcon className="button-icon" icon={['fas', 'plus']} />Channel hinzufügen</Button>
                        <Button onClick={this.update} type="button" ><FontAwesomeIcon className="button-icon" icon={['fas', 'sync']} />Liste neuladen</Button>
                    </div>
                }
                <FormMessageContainer/>
                {(() => {
                    switch (store.state) {
                        case "success":
                            return <DataTable headings={headings} rows={channels} onSort={null} />;
                        case "loading":
                            return <LoadingSpinner/>;
                        case "error":
                            return <InfoWrapper title="Laden der Daten nicht erfolgreich" info={store.errorMessage} type={InfoWrapperTypes.FAILURE} />;
                        case "edit":
                            return <EditChannel initalValues={store.selectedObject}/>;
                        case "delete":
                            return <DeleteChannel initalValues={store.selectedObject}/>;
                        case "add":
                            return <AddChannel />;
                        default:
                            return null;
                    }
                })()}
            </>
        );
    }
}

export default Channels;